<template>
  <div class="today-drop-items-container">
    <div class="drop-header">
      <h3>今日物品消耗 & 掉落统计</h3>
      <el-tag type="success">实时数据</el-tag>
    </div>

    <!-- 今日消耗统计 -->
    <div class="cost-stats">
      <el-statistic title="今日消耗金子" :value="todayTotalGold" suffix="个" />
      <el-statistic title="今日消耗铜钱" :value="todayTotalMoney" suffix="文" />
      <el-statistic title="今日掉落物品种类" :value="dropTypeCount" suffix="种" />
    </div>

    <!-- 物品列表 -->
    <div class="drop-table-container">
      <el-table
        :data="dropItemList"
        border
        stripe
        :loading="loading"
        header-bg-color="#1e293b"
        text-color="#fff"
      >
        <el-table-column label="物品名称" prop="itemName" align="center" />
        <el-table-column label="掉落数量" prop="count" align="center" />
      </el-table>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import axios from 'axios';

const props = defineProps({
  serverId: { type: String, default: '' },
  selectedDate: { type: String, default: '' },
  loading: { type: Boolean, default: false }
});

// 数据
const todayTotalGold = ref(0);
const todayTotalMoney = ref(0);
const dropItemList = ref([]);
const dropTypeCount = ref(0);

// 获取今日掉落数据
const getTodayDropData = async () => {
  if (!props.serverId) return;

  try {
    const res = await axios.get('https://log-inter.wuxiahaojie.com/api/GameResource/ServerCostGoldMoney', {
      params: {
        serverId: props.serverId,
        time: props.selectedDate || '所有'
      }
    });
    
    console.log("接口返回：", res.data);

    if (res.data?.code === 200 && res.data.data) {
      const data = res.data.data;
      
      // 消耗数据
      todayTotalGold.value = data.totalGold || 0;
      todayTotalMoney.value = data.totalMoney || 0;
      
      // 掉落物品字典 → 列表
      const list = [];
      if (data.serverGet) {
        for (const [name, cnt] of Object.entries(data.serverGet)) {
          list.push({ itemName: name, count: cnt });
        }
      }
      
      dropItemList.value = list;
      dropTypeCount.value = list.length;
    } else {
      clearData();
    }
  } catch (err) {
    console.error('请求出错：', err);
    clearData();
  }
};

const clearData = () => {
  todayTotalGold.value = 0;
  todayTotalMoney.value = 0;
  dropItemList.value = [];
  dropTypeCount.value = 0;
};

watch([() => props.serverId, () => props.selectedDate], () => {
  getTodayDropData();
});

onMounted(() => {
  getTodayDropData();
});
</script>

<style scoped>
.today-drop-items-container {
  padding: 16px;
  color: #ffffff;
  font-weight: 500;
}
.drop-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}
.drop-header h3 {
  color: #ffffff;
  font-weight: bold;
  font-size: 18px;
}
.cost-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

/* 数字、文字全部调亮 + 加粗 */
:deep(.el-statistic) {
  background: #1e293b;
  padding: 12px 16px;
  border-radius: 8px;
  min-width: 180px;
}
:deep(.el-statistic__title) {
  color: #e0e0e0 !important;
  font-weight: bold !important;
  font-size: 14px !important;
}
:deep(.el-statistic__content) {
  color: #ffffff !important;
  font-weight: bold !important;
  font-size: 18px !important;
}
:deep(.el-statistic__suffix) {
  color: #ffffff !important;
  font-weight: bold !important;
}

/* 表格文字改为黑色 */
.drop-table-container {
  background: #1e293b;
  padding: 12px;
  border-radius: 8px;
}
:deep(.el-table) {
  --el-table-text-color: #000000 !important; /* 关键：表格文字黑色 */
  --el-table-header-text-color: #ffffff !important; /* 表头文字保持白色 */
  font-weight: 500 !important;
}
</style>